import React, { useState, useEffect } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import SEO from '../components/common/SEO';
import { blogAPI } from '../utils/api';
import BlogPost from '../components/blog/BlogPost';
import Loading from '../components/common/Loading';
import ErrorMessage from '../components/common/ErrorMessage';

const BlogPostPage = () => {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPost = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await blogAPI.getBySlug(slug);
        setPost(response.data.data);
      } catch (err) {
        setError(err.message || 'Failed to load blog post');
      } finally {
        setLoading(false);
      }
    };

    fetchPost();
  }, [slug]);

  if (loading) {
    return <Loading fullScreen text="Loading blog post..." />;
  }

  if (error) {
    return (
      <div className="py-16 bg-bg-secondary min-h-screen">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <ErrorMessage message={error} />
        </div>
      </div>
    );
  }

  if (!post) {
    return <Navigate to="/blog" replace />;
  }

  return (
    <>
      <SEO
        title={`${post.title} - Blog | Confident Portraits`}
        description={post.excerpt || post.content?.substring(0, 160) || `Read ${post.title} on the Confident Portraits blog.`}
        image={post.coverImage}
        url={`/blog/${post.slug}`}
        type="article"
        keywords={post.tags?.join(', ')}
      />
      <BlogPost post={post} />
    </>
  );
};

export default BlogPostPage;
